

































































import Vue from 'vue'
import Component from 'vue-class-component'
import { State } from 'vuex-class'
import moment from 'moment'

import config from '../config'
import { Brand, Channel, Tag, Range, Campaign } from '../store/timeline'
import DateField from './DateField.vue'
import FalconIoRangeForm from './FalconIoRangeForm.vue'

interface RangeForm extends Range {
    valid: boolean,
    saving: boolean,
}

@Component({
    components: {
        DateField,
        FalconIoRangeForm,
    },
})
export default class FalconIoDialog extends Vue {
    @State(s => s.timeline.brands) brands!: Brand[]

    brandId: number | null = null
    start = moment().format('YYYY-MM-DD')
    end = moment().add(3, 'months').format('YYYY-MM-DD')
    loading = false
    ranges: Range[] = []

    visible = true
    valid = true

    items = [1,2,3,4,5,6]
    nextNum = 7


    requiredRules = [
        (v: any) => v !== '' && v !== null ? true : 'This field is required',
    ]

    dateRules = [
        (v: any) => v !== '' && v !== null ? true : 'This field is required',
        (v: any) => moment(v, 'YYYY-MM-DD').isValid() ? true : 'Invalid date format (YYYY-MM-DD)',
    ]

    randomIndex () {
        return Math.floor(Math.random() * this.items.length)
    }
    add () {
        this.items.splice(this.randomIndex(), 0, this.nextNum++)
    }
    remove () {
        this.items.splice(this.randomIndex(), 1)
    }

    async load() {
        let form: any = this.$refs.form
        if (!form.validate()) {
            return
        }
        this.loading = true
        try {
            const response = await this.$store.dispatch('api/get', {
                path: 'falcon.io/publish/items',
                params: {
                    brand_id: this.brandId,
                    start: moment(this.start).format('YYYY-MM-DD'),
                    end: moment(this.end).format('YYYY-MM-DD'),
                },
            })
            this.ranges = response.data.items.map((r: any) => ({
                ...r,
                title: '',
                tags: [],
                campaign_id: null,
            }))
        } finally {
            this.loading = false
        }
    }

    close() {
        this.$router.push({ name: 'home' })
    }

    removeRange(range: Range) {
        const idx = this.ranges.indexOf(range)
        this.ranges.splice(idx, 1)
    }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FalconIoDialog.vue